import apiClient from '../client';
import { ShippingOrderRequest, ShippingOrderResponse, ShippingStationListResponse } from '@shared/types';

export interface OrderItemForReceive {
  itemNumber: string;
  partNumber: string;
  description: string;
  status: string;
  actionId: number;
  isReceived: boolean;
  statusDate?: Date;
}

export interface OrderForReceive {
  orderNumber: string;
  customerId: string;
  customerName: string;
  shipVia: string;
  isDropShip: boolean;
  itemCount: number;
}

export interface GetOrderItemsResponse {
  success: boolean;
  order: OrderForReceive;
  items: OrderItemForReceive[];
  allReceived: boolean;
}

export interface ReceiveItemResponse {
  success: boolean;
  message: string;
  item?: {
    itemNumber: string;
    partNumber: string;
    description: string;
  };
}

export const shippingService = {
  /**
   * Get shipping station list (orders in Trimming/Packaging)
   */
  getShippingStationList: async (page: number = 1, search?: string): Promise<ShippingStationListResponse> => {
    const response = await apiClient.get('/shipping/list', { params: { page, search: search || undefined } });
    return response.data;
  },

  /**
   * Get order for shipping/invoice printing
   */
  getOrderForShipping: async (orderNumber: string): Promise<ShippingOrderResponse> => {
    const request: ShippingOrderRequest = { orderNumber };
    const response = await apiClient.post('/shipping/order', request);
    return response.data;
  },

  /**
   * Get order items for receive modal
   */
  getOrderItemsForReceive: async (orderNumber: string): Promise<GetOrderItemsResponse> => {
    const response = await apiClient.get(`/shipping/order-items/${orderNumber}`);
    return response.data;
  },

  /**
   * Receive a single item
   */
  receiveItem: async (itemNumber: string): Promise<ReceiveItemResponse> => {
    const response = await apiClient.post('/shipping/receive-item', { itemNumber });
    return response.data;
  },
};
